import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CoreCommonModule } from '@core/common.module';

import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';

import { SampleComponent } from './sample.component';
import { HomeComponent } from './home.component';
import {AuthGuard} from "../../auth/helpers";
import {NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";
import {ChartsModule} from "ng2-charts";

const routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: HomeComponent,
    data: { animation: 'home' }
  },
  {
    path: 'sample',
    component: SampleComponent,
    data: { animation: 'sample' }
  }
];

@NgModule({
  declarations: [SampleComponent, HomeComponent],
  imports: [RouterModule.forChild(routes), ContentHeaderModule, TranslateModule, CoreCommonModule, NgbDropdownModule, ChartsModule],
  exports: [SampleComponent, HomeComponent]
})
export class SampleModule {}
